import { faSignOut, faTimes, faV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CALLDASHBOARD, SIGNIN } from 'src/common/constants';
import { SideMenu, sidemenu } from 'src/common/menu';
import useEventListener from 'src/hooks/useEventListener';
import { logout } from 'src/store/slices/authSlice';
import { callDetailModal, closeReportModal } from 'src/store/slices/callSlice';
import { setActiveSidemenu, setSidebarState } from 'src/store/slices/settingsSlice';
import { RootState } from 'src/store/store';
import logo from '../assets/images/aiva-logo-black.svg';
import smallLogo from '../assets/images/logo192.png'

const Sidebar = () => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const { sidebarState } = useSelector((state: RootState) => state.settings);
  const username = 'Admin'

  const handleLogout = async () => {
    dispatch(logout());
    navigate(SIGNIN);
    dispatch(callDetailModal(false));
    dispatch(closeReportModal());
  }

  const handleResize = () => {
    if (window.innerWidth < 768) {
      dispatch(setSidebarState('collapsed'))
    }
  };

  const handleSidebarCloseBtn = () => {
    dispatch(setSidebarState('collapsed'))
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      dispatch(setSidebarState('collapsed'))
    }
  }, [])

  useEventListener('resize', handleResize)

  return (
    <div className={`sidebar ${sidebarState}`}>
      <button className='btn btn-close-sidebar' onClick={handleSidebarCloseBtn}>
        <FontAwesomeIcon icon={faTimes} size='2xl' />
      </button>
      <div className='sidebar-header'>
        <Link to={CALLDASHBOARD} className='sidebar-logo' onClick={() => dispatch(setActiveSidemenu('VOXA'))}>
          <img src={logo} alt="logo" className='full-logo' />
          <img src={smallLogo} alt="logo" className='small-logo' />
        </Link>
      </div>
      <div className='sidebar-menu-title w-100 text-center mb-2 mt-1'>Welcome {username}!</div>
      <div className='sidebar-menu-wrapper'>
        {sidemenu.map((menu: SideMenu) => {
          return (
            <SideMenuItem key={menu.name} menu={menu} />
          )
        })}
      </div>
      <div className='sidebar-footer'>
        <button className='btn btn-primary border-0 sidebar-menu-link justify-content-center' onClick={handleLogout}>
          <span className='sidebar-menu-icon'>
            <FontAwesomeIcon icon={faSignOut} flip='horizontal' />
          </span>
          <span className='sidebar-menu-title'>Logout</span>
        </button>
      </div>
    </div>
  )
}

export default Sidebar

interface SideMenuItemProps {
  menu: SideMenu
}
const SideMenuItem: FC<SideMenuItemProps> = ({ menu }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch()
  const { activeSidemenu } = useSelector((state: RootState) => state.settings);
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  useEffect(() => {
    const activeMenu = sidemenu?.find(menu => menu?.name === activeSidemenu);
    const isMatchPath = activeMenu?.path === pathname || activeMenu?.path?.startsWith(pathname);
    if (!isMatchPath) {
      const newActiveMenu = sidemenu?.find((menu) => menu?.path === pathname || menu?.path?.startsWith(pathname));
      if (newActiveMenu) dispatch(setActiveSidemenu(newActiveMenu?.name))
    }
    //eslint-disable-next-line
  }, [pathname, activeSidemenu])

  // Determine if this menu is active
  const isActive = menu.name === activeSidemenu;

  useEffect(() => {
    if (!isActive) {
      linkRef?.current?.blur();
    }
  }, [isActive])

  return (
    <div className={`sidebar-menu-item ${isActive ? 'active' : ''}`}>
      <Link ref={linkRef} to={menu.path} className='sidebar-menu-link' onClick={() => dispatch(setActiveSidemenu(menu.name))}>
        <span className='sidebar-menu-title'>{menu.name}</span>
        <span className='sidebar-menu-icon'>
          <FontAwesomeIcon icon={menu.icon} />
        </span>
      </Link>
    </div>
  )
}
